export const STRATEGY_ADDRESSES_TO_NAME: Record<string, string> = {
    "0xAc612bb9eF0207FaCEED3D3E615e91CB65c34cbE": "Basis Trade Testnet",
    "0xd7d1580a09A1Bb4C466295432045E2702ae71C2F": "Basis Trade",
};

export const STRATEGIES_LIST = Object.keys(STRATEGY_ADDRESSES_TO_NAME);
